import { ApolloClient } from '@apollo/client';
import { isProjectNetSRPActive } from '../common/helpers/constants';
import { searchProjects } from '../frontend-service/project-api';
import { ProjectFilterParams, queryProjects } from './search';
import { ProjectQueryData } from '../queries/searchPage/searchProjects';
import logger from '../common/helpers/logger/logger';

export const projectManager = async (
  offset: number,
  searchQuery: ProjectFilterParams,
  client: ApolloClient<unknown>,
  perPage: number,
): Promise<ProjectQueryData['projectListCarouselQuery']> => {
  try {
    if (isProjectNetSRPActive()) {
      // Use the Next.js API
      return await searchProjects(offset, searchQuery, perPage);
    } else {
      // Use the GraphQL-based search
      return await queryProjects(offset, searchQuery, client, perPage);
    }
  } catch (error) {
    logger.logError('projectManager', 'Error retrieving project data.', {
      error,
      isProjectNetSRPActive: isProjectNetSRPActive(),
      searchQuery,
    });
  }
};
